(function () {
    'use strict';

    angular.module('swif.framework')
    .service('swifOAuthService', oauthService);


    /**
        * @ngdoc service
        * @name swif.framework.oauthService
        * @requires swif.framework.actionService
        * @requires swif.framework.dataService
        * @requires swif.framework.userService
        * @requires swif.framework.settingsService
        * @requires swif.framework.swifModule
    **/
    function oauthService(actionService, dataService, userService, settings, swifModule, $timeout, $location, $q) {
        'ngInject';
        var service = {
            getOauthProviders: getOauthProviders,
            dispatchLogin: dispatchLogin,
            singleSignOut: singleSignOut,
            formatUrl: formatUrl,
            oauth: {retrying: false, providers: []}
        };
        return service;

        /**
         * @ngdoc method
         * @name dispatchLogin
         * @methodOf swif.framework.oauthService
         * @param {Function} callback that will be called once the login is done
         * @description 
         * parse search params, if find 'code' + 'state', or 'error' alone,
         * expects this is a redirect from an oauth authentication server
         */
        function dispatchLogin(callback) {
            var searchValues = $location.search();
            var code = searchValues.code;
            var state = searchValues.state;
            var error = searchValues.error;
            if (error) {
                service.oauth.error = error;
            }
            else if (code && state) {
                state = JSON.parse(state);
                var action = actionService.getActionById('user', 'user', 'oauth_login', {});
                var data = {
                    db: settings.app.db,
                    authentication_code: code,
                    oauth_provider_id: state.provider_id
                };
                actionService.dispatch(
                    'user',
                    action,
                    data,
                    {callback: callback}
                );
            }
        }


        /**
         * @ngdoc method
         * @name getOauthProviders
         * @methodOf swif.framework.oauthService
         * @description 
         * @returns {Array} of providers objects
         */
        function getOauthProviders () {
            if (!swifModule.modules.opengst_oauth) {
                return $q.when([]);
            }
            var http = {url: '/web/oauth/list_providers'};
            var user = userService.getAuthenticatedUser();
            http.params = {db: settings.app.db};
            return dataService.post('user', http, false).then(function (data) {
                service.oauth.retrying = false;
                service.oauth.providers = data;
                _.forEach(service.oauth.providers, function (provider) {
                    // var state = 'provider_id='+ provider.id;
                    var state = {provider_id: provider.id};
                    var url = provider.auth_endpoint;
                    var params = {
                        state: JSON.stringify(state),
                        response_type: provider.auth_type === 'auth_code' ? 'code' :'token',
                        redirect_uri: provider.redirect_uri || '',
                        client_id: provider.client_id || '',
                        scope: provider.scope || ''
                    };
                    // crapyyyyyyyyyyyyyyyyyyyyyyyy !
                    if (url.toLowerCase().includes('ozwillo')) {
                        params.noonce = moment().unix() * 1000 + Math.floor(Math.random() * 1000);
                    }

                    url = formatUrl(url, params);
                    
                    provider.providerUrl = url;
                });
                return service.oauth.providers;
            }, function (err) {
                if (!service.oauth.retrying) {
                    return $timeout(function () {
                        service.oauth.retrying = true;
                        return getOauthProviders();
                    }, 1500);
                } else {
                    return err;
                }
            });
        }

        /**
         * @ngdoc method
         * @name singleSignOut
         * @methodOf swif.framework.oauthService
         * @description handle signle sign out (ozwillo)
         * @returns {Promise} of ?
         */
        function singleSignOut(test) {
            if (!swifModule.modules.opengst_oauth) {
                return $q.when({});
            }
            var url = 'oauth_signout';
            if (test) {
                url = 'oauth_signout_test';
            }
            return dataService.callKw('user', url);
        }

        /**
         * @ngdoc method
         * @name formatUrl
         * @methodOf swif.framework.oauthService
         * @description Takes an url and appends params to it
         * @returns {String} formatted url
         */
        function formatUrl(url, params) {
            if (!url) {
                return url;
            }

            if (!url.includes('?')) {
                url += '?';
            } else {
                url += '&';
            }

            var urlParams = [];
            _.forEach(params, function (val, key) {
                urlParams.push(key + '=' + encodeURIComponent(val));
            });

            url += urlParams.join('&');

            return url;
        }
    }



})();